<template>
  <div class="page-selector container d-flex flex-wrap mb-3">
    <div>
      <ncs-pagination-title/>
      <ncs-pagination-links/>
    </div>
    <ncs-go-to-page class="mx-auto"/>
    <div class="ms-auto align-self-end mt-3">
      <ncs-download-button/>
    </div>
  </div>
</template>
